import React from "react";
import PropTypes from "prop-types";
import { Link } from "@quintype/components";

import styles from "./styles.m.css";
import { Icon } from "../../../atoms/icon";

const SubscriptionLink = ({ href, text = "Subscribe to vikatan" }) => {
  return (
    <div className={styles["subs-link-wrapper"]}>
      <Link
        aria-label="Subscribe"
        className={`${styles["subscription-link"]} hidden-desktop`}
        rel="noopener noreferrer"
        target="_blank"
        href={"https://vikatanmobile.page.link/website_header_text_mobile"}
        callback={() => {
          if ("ga" in window) {
            window.ga("send", "event", "app-install-header-mob", "Clicked", window.location.href);
          }
        }}
      >
        <div className={styles["app-install"]}>
          <div className={styles["price-point"]}>
            <Icon type={"rupee"} className={styles["rupee-icon"]} />
            <span className={styles["price-amount"]}>
              500
              <i className={styles["astrik"]}>*</i>
            </span>
          </div>
          <div className={styles["app-install-text"]}>
            மதிப்புள்ள 30 இதழ்களை <span className={styles["text-red"]}>இலவசமாகப் படிக்க</span>
          </div>
          <div className={styles["app-install-cta"]}>Install App</div>
        </div>
      </Link>
    </div>
  );
};
SubscriptionLink.propTypes = {
  href: PropTypes.string,
  text: PropTypes.string
};

export default SubscriptionLink;
